import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var UndoSVG = function UndoSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M5,2A1,1,0,0,1,6,3v8.272L12.64,4.636A9,9,0,0,1,25.368,17.364L13.025,29.707a1,1,0,0,1-1.414-1.414L23.954,15.95a7,7,0,0,0-9.9-9.9L7.105,13H16a1,1,0,0,1,0,2H5.5A1.5,1.5,0,0,1,4,13.5V3A1,1,0,0,1,5,2Z"
  }));
};
UndoSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UndoSVG);